import type { ParticipantCoupon } from '../api/participant-api';

function time(value: string | null): number {
  if (!value) return 0;
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? 0 : t;
}

/**
 * Ativos (ATRIBUIDO) primeiro, o que vence antes no topo; depois os usados e
 * expirados, do mais recente para o mais antigo.
 */
export function splitCoupons(coupons: ParticipantCoupon[]): { active: ParticipantCoupon[]; past: ParticipantCoupon[] } {
  const active = coupons
    .filter((c) => c.status === 'ATRIBUIDO')
    .sort((a, b) => (time(a.expiresAt) || Infinity) - (time(b.expiresAt) || Infinity));
  const past = coupons
    .filter((c) => c.status !== 'ATRIBUIDO')
    .sort((a, b) => time(b.usedAt ?? b.expiresAt ?? b.assignedAt) - time(a.usedAt ?? a.expiresAt ?? a.assignedAt));
  return { active, past };
}

/** Dias inteiros até o fim da validade (0 = vence hoje). `null` sem data. */
export function daysLeft(expiresAt: string | null, now = Date.now()): number | null {
  if (!expiresAt) return null;
  const end = new Date(expiresAt).getTime();
  if (Number.isNaN(end)) return null;
  return Math.max(0, Math.floor((end - now) / 86_400_000));
}

export function expiryText(expiresAt: string | null, now = Date.now()): string | null {
  const days = daysLeft(expiresAt, now);
  if (days === null) return null;
  if (days === 0) return 'Vence hoje';
  if (days === 1) return 'Vence amanhã';
  if (days <= 7) return `Vence em ${days} dias`;
  return `Válido até ${new Date(expiresAt as string).toLocaleDateString('pt-BR')}`;
}
